import { createFileRoute, Link } from "@tanstack/react-router";
import { SetupCopyBlock } from "@/components/setup/SetupCopyBlock";

export const Route = createFileRoute("/docs/inviting-members")({
	component: InvitingMembers,
});

function InvitingMembers() {
	return (
		<article className="space-y-10">
			<div className="space-y-2">
				<h1 className="text-2xl font-semibold tracking-[-0.04em]">
					Inviting members
				</h1>
				<p className="text-sm text-muted-foreground">
					Collaborate with your team inside a workspace.
				</p>
			</div>

			<div className="space-y-4 text-sm leading-relaxed text-muted-foreground">
				<p>
					Workspaces let you collaborate with your team. Each workspace has its
					own connections, posts, and settings.
				</p>
				<p>Tell your assistant things like:</p>
				<div className="grid gap-2">
					<SetupCopyBlock
						text="Invite alice@example.com to this workspace."
						multiline
					/>
					<SetupCopyBlock
						text="Add a new team member with email bob@example.com."
						multiline
					/>
					<SetupCopyBlock text="Who is in this workspace?" multiline />
				</div>
				<p>
					The assistant uses{" "}
					<code className="rounded bg-muted px-1.5 py-0.5 text-xs font-mono text-foreground">
						teamAction
					</code>{" "}
					to send the invitation and{" "}
					<code className="rounded bg-muted px-1.5 py-0.5 text-xs font-mono text-foreground">
						teamAction
					</code>{" "}
					to see who is currently in the workspace.
				</p>

				<h2 className="text-base font-medium text-foreground pt-2">
					Or use the dashboard
				</h2>
				<ol className="list-decimal pl-5 space-y-2">
					<li>
						Navigate to the <strong className="text-foreground">Members</strong>{" "}
						tab in your dashboard.
					</li>
					<li>
						Click <strong className="text-foreground">Invite Member</strong> and
						enter the email address of the person you want to add.
					</li>
					<li>
						Choose a role for the new member (see{" "}
						<Link
							to="/docs/roles"
							className="text-primary hover:text-primary/80 transition-colors"
						>
							Roles and permissions
						</Link>
						).
					</li>
					<li>
						The invitee receives an email with a link to join the workspace.
						Once they accept, they appear in the members list.
					</li>
				</ol>
				<p>
					You can remove a member or change their role at any time from the
					Members page.
				</p>
			</div>

			<div className="flex items-center gap-4 text-sm">
				<Link
					to="/docs/calendar"
					className="text-muted-foreground hover:text-foreground transition-colors"
				>
					&larr; Using the calendar
				</Link>
				<Link
					to="/docs/roles"
					className="text-primary hover:text-primary/80 transition-colors ml-auto"
				>
					Roles and permissions &rarr;
				</Link>
			</div>
		</article>
	);
}
